import { styled } from "styletron-react";

const EmptyCaption = styled("div", { height: "5px" });

export default EmptyCaption;
